import React, { Component } from 'react';
import './styles.css';

export default class Settings extends Component {
  render() {
    return (
      <div className="dashboard">
        <h1>Settings Page</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Settings/Settings.js